import {isFulfilled, isRejectedWithValue} from '@reduxjs/toolkit'
import {toast} from 'react-hot-toast'
const REUEST_ENDPOINTNAMES = [
    'createDanceMedia',
    'danceFavoriteMedia',
    'cancelDeleteRequest',
    'deleteDanceMedia',
]
const rtkQueryToasterHandler = (api) => (next) => (action) => {
    if (action.meta) {
        const endpointName = action.meta.arg.endpointName
        const isDesirableEndpoint = REUEST_ENDPOINTNAMES.some(
            (endpoint) => endpoint === endpointName
        )
        if (isDesirableEndpoint) {
            const payload = action.payload
            if (isFulfilled(action)) {
                // const fulfilledResponesMessage = action.payload
                toast.success('success')
            }
            if (isRejectedWithValue(action)) {
                const errorResponesMessage = payload.data.error

                toast.error(errorResponesMessage)
            }
        }
    }

    return next(action)
}
export default rtkQueryToasterHandler
